import React from "react";

function SpinningFlower() {
    return (
        <>
            <img src={require("../IMG/flower.png")} alt="flower" className="spinningFlower" />
        </>
    );
}

export default SpinningFlower;